import $ from 'jquery'
import vue from 'vue'
import axios from 'axios'
import store from './store';
import env from './../../src/common/env.js';
import {
    wxGetAppId
} from "./../../src/api/personal.js";
import { resolve, reject } from 'when';
//----------------------

////定义全局变量
var wx = '';

var appId = '';

var openId = '';

//当前页面url
var url = '';

//微信授权code
var code = '';

//url中的分享人openId参数
var shareOpenId = '';
var pageId = '';
var pageType = '';
var shareType = '';

//微信重定向uri中的state
var state = '';

//入口函数
export function getUserOpenId() {
    let p = new Promise((resolve, reject) => {

        wx = require('weixin-js-sdk');
        url = window.location.href;

        //必须在方法内获取sessionStorage，在全局变量处获取会为空值!!!
        openId = sessionStorage.getItem("ltmOpenId");
        //如果不存在openId,则需要调用微信接口
        if (!openId) {
            ////获取APPID
            // $.ajax({
            //     url: '/wxapim/wxapi/wxGetAppId',
            //     type: 'get',
            //     async: false,
            //     success: function(res) {
            //         appId = res;
            //         getOpenId();
            //     },
            //     error: function() {
            //         alert('获取appid失败，请联系管理员')
            //     }
            // })


            wxGetAppId().then(res => {
                appId = res.data
                getOpenId()
                resolve(true);
            }).catch(err => {
                alert('获取appid失败，请联系管理员')
            })



        }

    })
    return p;
}


//根据code以及openId是否存在来决定是否调用网页授权
function getOpenId() {
    code = GetUrlQueryString('code');
    state = GetUrlQueryString('state');

    //这四个字段是分享链接中带的四个参数,用于生成分享以及访问记录
    shareOpenId = GetUrlQueryString('shareOpenId')
    pageId = GetUrlQueryString('pageId');
    pageType = GetUrlQueryString('pageType');
    shareType = GetUrlQueryString('shareType');

    // console.log("redirectState", state);

    //判断state => 如果state参数不是固定值或者不为null,说明其中带有需要解析的参数
    if (state != 'state' && state != null) {
        //state中的字符串若不为空且不是state，说明存储了shareOpenId以及pageId（自定义），分隔字符串的标识经过urlEncode，要注意
        var splitStr = state.split('%3A');
        console.log("splitStr", splitStr);
        if (splitStr[0].split('%3D')[0] == 'shareOpenId') {
            shareOpenId = splitStr[0].split('%3D')[1];
        }
        if (splitStr[1].split('%3D')[0] == 'pageId') {
            pageId = splitStr[1].split('%3D')[1];
        }
        //!!pageType
        if (splitStr[2].split('%3D')[0] == 'pageType') {
            pageType = splitStr[2].split('%3D')[1];
        }
        //!!shareType
        if (splitStr[3].split('%3D')[0] == 'shareType') {
            shareType = splitStr[3].split('%3D')[1];
        }

        // var strSplit = state.split('%3D')
        // if (strSplit[0] == 'shareOpenId') {
        //     shareOpenId = strSplit[1]
        // }
    }

    //若存在code,要判断openId是否已存在,
    if (code) {

        console.log("code", code);
        console.log("pageId", pageId);
        console.log("pageType", pageType);
        console.log("shareType", shareType);


        //若cookie中不存在openID,需要先获取token再拉取用户信息
        if (!openId) {
            $.ajax({
                url: '/wxapi-web/wxapi/wxGetAuthorizeUserInfoByCode',
                type: 'get',
                data: {
                    code: code,
                    shareOpenId: shareOpenId === null ? null : shareOpenId,
                    pageId: pageId === null ? null : pageId,
                    pageType: pageType === null ? null : pageType,
                    shareType: shareType === null ? null : shareType,
                    sharePageUrl: url
                },
                async: false,
                success: function(res) {
                    if (res.code === -1) {
                        console.log('错误信息: ' + res.msg);
                        return false;
                    };
                    //赋值
                    openId = res.data.userInfo.openid;
                    vue.openId = openId;
                    store.commit("setUserInfo", true);
                    sessionStorage.setItem("ltmOpenId", openId);

                },
                error: function() {
                    console.log('wxGetAuthorizeUserInfoByCode error')
                }
            })
        }
    } else {
        //如果code不存在，且openId不存在时 => 用appid以及url调用微信授权api => 若页面链接存在参数,需要将参数存储到state中 => 微信跳转redirect_url
        if (!openId) {
            //设定一个固定值，用于上方取参判断state是否有携带参数
            state = 'state'

            //只考虑链接一个参数的情况下，直接将分享人openId存储到state中
            //!!现在加入了pageId
            if (shareOpenId) {
                state = 'shareOpenId=' + shareOpenId;
            }
            //state参数不能使用&号分隔!!!
            if (pageId) {
                state = state + ':pageId=' + pageId;
            }
            if (pageType) {
                state = state + ":pageType=" + pageType;
            }
            if (shareType) {
                state = state + ':shareType=' + shareType;
            }

            var strScope = "snsapi_userinfo";

            var redirectURI = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri=" + url + "&response_type=code&scope=" + strScope + "&state=" + state + "#wechat_redirect"

            console.log("redirectUri", redirectURI);
            //跳转
            if (env.bool) {
                window.location.href = redirectURI;
            } else {}

        }
    }
}





//公用方法


//获取url中的参数值
//获取链接中的参数
function GetUrlQueryString(name) {

    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')

    var r = window.location.search.substr(1).match(reg)
    if (r !== null) return (r[2])
    return null

}


//////////////////
// WEBPACK FOOTER
// ./static/js/openId.js
// module id = nZf/
// module chunks = 52